import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { useI18n } from '../../i18n';
import './NoticeboardSection.css';

const ViewNoticeModal = ({ notice, onClose }) => {
    const { locale, t } = useI18n();
    if (!notice) return null;

    const localeCode = locale === 'en' ? 'en-GB' : (locale || 'en');

    return (
        <div className="notice-composer-overlay">
            <div className="notice-composer-modal">
                <div className="notice-composer-header">
                    <h3 className="notice-composer-title">{t('legacy.view_notice_title')}</h3>
                    <button className="notice-composer-close" onClick={onClose} aria-label={t('common.actions.close')}>
                        <FaTimes />
                    </button>
                </div>

                <div className="notice-composer-body">
                    <div className="view-notice-content">
                        {/* Title Section */}
                        <div className="view-notice-header-group">
                            <label className="view-notice-label">{t('legacy.notice_title_label')}</label>
                            <div className="view-notice-title-text">
                                {notice.title}
                            </div>
                        </div>

                        {/* Description Section */}
                        <div className="view-notice-description-group">
                            <label className="view-notice-label" style={{ marginBottom: '8px', display: 'block' }}>{t('common.labels.description')}</label>
                            <div className="view-notice-description-text">
                                {notice.description}
                            </div>
                        </div>

                        {/* Metadata Section */}
                        <div className="view-notice-meta-row">
                            <div className="view-notice-meta-item">
                                <label className="view-notice-label">{t('common.labels.date')}</label>
                                <div className="view-notice-meta-value">
                                    {new Date(notice.date).toLocaleDateString(localeCode, {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric'
                                    })}
                                </div>
                            </div>

                            <div className="view-notice-meta-item">
                                <label className="view-notice-label">{t('common.labels.time')}</label>
                                <div className="view-notice-meta-value">
                                    {notice.time}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="notice-composer-footer">
                    <button
                        type="button"
                        className="notice-composer-btn notice-composer-btn-secondary"
                        onClick={onClose}
                    >
                        {t('common.actions.close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewNoticeModal;
